import React, { Component } from "react";
import { connect } from "react-redux";

import {
  Card,
  Table,
  Select,
  Input,
  Button,
  Tooltip,
  Image,
  DatePicker,
} from "antd";
import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { getDateYYYYMMDD, formateDate } from "../../utils/dateUtil";
import { usrRole } from "../../utils/dataUtil";
import {
  req_page_gsm_singer_enrolment_range,
  req_downloadfile_gsm_history_range,
} from "../../api";
const { RangePicker } = DatePicker;

class SignerEnrolmentHistoryList extends Component {
  state = {
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: getDateYYYYMMDD(new Date()),
    isShowModal: false,
    startDateTime: "",
    endDateTime: "",
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    this.api_page_items(1);
  }
  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      startDateTime,
      endDateTime,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_gsm_singer_enrolment_range(
      userLevel,
      userCode,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      startDateTime,
      endDateTime,
      token
    );
    //console.log(result);
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination, loading: false });

      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination, loading: false });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      startDateTime,
      endDateTime,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_gsm_history_range(
      userCode,
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      startDateTime,
      endDateTime,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 操作互動處理 //////////////////////////////////////////////
  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  onRangePickerChange = (value, dateString) => {
    //console.log("Selected Time: ", value);
    //console.log("Formatted Selected Time: ", dateString);
    this.setState({
      startDateTime: dateString[0],
      endDateTime: dateString[1],
    });
  };
  onRangePickerOk = (value) => {
    //console.log("onOk: ", value);
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    this.columns = [
      {
        title: "登記時間",
        width: 30,
        render: (item) => {
          const { RecordCreateDateTime } = item;
          return (
            <span style={{ color: "red", fontSize: "1.3em" }}>
              {formateDate(RecordCreateDateTime)}
            </span>
          );
        },
      },
      {
        title: "組織名稱",
        dataIndex: "DepartmentMainName",
        width: 40,
        responsive: ["md"],
      },
      {
        title: "照片",
        width: 30,
        responsive: ["md"],
        render: (item) => {
          const { SignUserCode } = item;
          const picUrl =
            SignUserCode.length < 7
              ? "https://rm.tut.edu.tw/ab/DisplaySmallPicture.ashx?p=pic/" +
                SignUserCode +
                ".jpg&w=80&h=100"
              : "https://stu95.tut.edu.tw/SC2008/PHOTO/" +
                SignUserCode +
                ".jpg";
          return (
            <div>
              <Image width={80} src={picUrl} />
            </div>
          );
        },
      },
      {
        title: "姓名",
        dataIndex: "StaffName",
        width: 30,
        responsive: ["md"],
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em", fontWeight: "bold" }}>
                {" "}
                {field}
              </span>
            </div>
          );
        },
      },
      {
        title: "身分證字號",
        dataIndex: "StaffCode",
        width: 20,
        render: (field) => {
          return (
            <div>
              <span style={{ fontSize: "1.3em", fontWeight: "bold" }}>
                {" "}
                {field}
              </span>
            </div>
          );
        },
      },
      {
        title: "學|職號",
        dataIndex: "SignUserCode",
        width: 20,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}> {field}</span>
            </div>
          );
        },
      },
      {
        title: "入|離校",
        dataIndex: "SignStatus",
        width: 20,
        responsive: ["md"],
        render: (field) => {
          return (
            <div
              className="text-center"
              style={
                field === "IN"
                  ? { backgroundColor: "#ffb3d9", color: "#943126" }
                  : { backgroundColor: "#ABEBC6", color: "#0B5345" }
              }
            >
              <span> {field === "IN" ? "入校" : "離校"}</span>
            </div>
          );
        },
      },
      {
        title: "登記位置",
        dataIndex: "SchoolGateLocation",
        width: 30,
        responsive: ["md"],
        render: (field) => {
          return (
            <div className="text-center">
              <span
                style={
                  field === "第一校門"
                    ? {
                        color: "#e65c00",
                        fontWeight: "bold",
                        fontSize: "1.3em",
                      }
                    : {
                        color: "#002db3",
                        fontWeight: "bold",
                        fontSize: "1.3em",
                      }
                }
              >
                {" "}
                {field}
              </span>
            </div>
          );
        },
      },
    ];
  };

  /////////////////////////////////////////////////////////////
  render() {
    const {
      loading,
      searchField,
      searchValue,
      pagination,
      items,
      startDateTime,
    } = this.state;
    console.log(startDateTime);
    const title = (
      <>
        <RangePicker
          showTime={{
            format: "HH:mm",
          }}
          format="YYYY-MM-DD HH:mm"
          onChange={this.onRangePickerChange}
          onOk={this.onRangePickerOk}
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="StaffName">姓名</Select.Option>
          <Select.Option value="StaffCode">身分證後三碼</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>下載</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <p />
      </>
    );
    return (
      <Card>
        {title}
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="Uid"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
      </Card>
    );
  }
}

export default connect(
  (state) => ({ user: state.user }),
  {}
)(SignerEnrolmentHistoryList);
